import "./NewChat.scss";
import Lottie from "lottie-react";
import { useMemo } from "react";
import { MdOutlineAutoAwesome } from "react-icons/md";
import { useSelector } from "react-redux";
import { HorizontalCard } from "../../Components/HorizontalCard/HorizontalCard";
import * as UserRedux from "../../redux/user";
import buttonAnimation from "../llm-lottie.json";
import { getPromptLibrary } from "../LLMConstants";

interface NewChatProps {
  onSelect: (prompt: string) => void;
}

export const NewChat = ({ onSelect }: NewChatProps): JSX.Element => {
  const userName = useSelector(UserRedux.fullNameSelector);
  const firstNameStr = useMemo(() => (userName ? userName.split(/\s+/)[0] : ""), [userName]);

  // Randomly grab 3 prompts from the list
  const suggestedPrompts = useMemo(() => {
    const promptLibrary = getPromptLibrary();
    return promptLibrary.sort(() => 0.5 - Math.random()).slice(0, 3);
  }, []);

  return (
    <div className="newChatContainer">
      <div className="header">
        <Lottie animationData={buttonAnimation} loop className="headerIcon" />
        <div className="headerText">
          {firstNameStr && <h1 className="greeting">Hey, {firstNameStr}!</h1>}
          <h1 className="cta">Let's dive into your data.</h1>
        </div>
      </div>
      <div className="promptContainer">
        {suggestedPrompts.map((prompt, index) => (
          <HorizontalCard
            key={`suggested-p
            size="lg"rompt-${index}`}
            leadingElement={<MdOutlineAutoAwesome size={20} />}
            bodyText={prompt.label}
            onClick={() => onSelect(prompt.value)}
          />
        ))}
      </div>
      <div className="disclaimer">Cross Channel page data only.</div>
    </div>
  );
};
